import { Controller } from "@hotwired/stimulus"

export default class TemplateTogglerController extends Controller {
  static targets = [ "link", "container", "stage", "template" ]
  static values = { activeClass: String }

  toggle(event) {
    event.preventDefault()

    const link = event.currentTarget
    if(!this._isActiveLink(link)) {
      this._setActiveLink(link)
      this._swapStageAndTemplate()
    }
  }

  _swapStageAndTemplate() {
    const stageHTML = this.stageTarget.innerHTML;
    const templateHTML = this.templateTarget.innerHTML;
    this.stageTarget.innerHTML = templateHTML;
    this.templateTarget.innerHTML = stageHTML;
  }

  _setActiveLink(link) {
    this._inactivateLinks()
    this._activateLink(link)
  }

  _inactivateLinks() {
    this.linkTargets.forEach(target => {
      target.classList.remove(this.activeClassValue)
  })
  }

  _isActiveLink(link) {
    return link.classList.contains(this.activeClassValue)
  }

  _activateLink(link) {
    link.classList.add(this.activeClassValue)
  }
}
